import React, { useState } from 'react';

const ZygoSecBlogPost = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div style={styles.container}>
      <style>{`
        @media (max-width: 768px) {
          .nav-links { display: none !important; }
          .mobile-menu-btn { display: flex !important; }
          .article-title { font-size: 32px !important; }
          .article-content { padding: 0 20px !important; }
        }
      `}</style>

      {/* Dot pattern background */}
      {/* <div style={styles.dotPattern} /> */}

      {/* Navigation */}
      <nav style={styles.nav}>
        <div style={styles.navInner}>
          <div style={styles.logo}>
           <a href="https://zygosec.com">
            <img style={{width: '100px', padding: 0, margin: 0}} class="w-[100px] p-0 m-0" src={require('../images/zygosec-dark.png')} id="logo"/>
           </a>
          </div>
          <div className="nav-links" style={styles.navLinks}>
            <a href="/blog" style={styles.navLink}>Blog</a>
            <a href="/about" style={styles.navLink}>About</a>
          </div>
        </div>
        {menuOpen && (
          <div style={styles.mobileMenu}>
            <a href="/blog" style={styles.mobileNavLink}>Blog</a>
            <a href="/about" style={styles.mobileNavLink}>About</a>
          </div>
        )}
      </nav>


      {/* Article Header */}
      <header style={styles.articleHeader}>
        <div style={styles.headerContent}>

          <br></br>
          <br></br>

        
          
          <h1 className="article-title" style={styles.articleTitle}>
            Uncovering an iOS 26 ImageIO Vulnerability (CVE-2026-28990)
          </h1>
          <p style={styles.articleSubtitle}>
            In this blog we conduct a root-cause-analysis and build a working PoC for a recent iOS image parsing vulnerability patched in iOS 26.5.
          </p>
          <div style={styles.articleMeta}>
            <div style={styles.authorInfo}>
              <div style={styles.authorAvatar}></div>
              <div>
                <span style={styles.authorName}>Billy Ellis</span>
                <span style={styles.articleDate}>May 25th, 2026 · 8 min read</span>
              </div>
            </div>
           
          </div>
        </div>
      </header>

        {/* Hero Image */}
      <div style={styles.heroImage}>
        <div style={styles.heroImageInner} />
      </div>

      {/* Article Content */}
      <article className="article-content" style={styles.articleContent}>
        <div style={styles.prose}>

          <p style={styles.paragraph}>
             iOS 26.5 patched a number of vulnerabilities, with 3 of the total assigned CVEs being for bugs in the <code style={styles.inlineVariable}>ImageIO</code> framework. <code style={styles.inlineVariable}>ImageIO</code> is an Apple shared library that handles a variety of image parsing logic. It is known historically to have been a 'hot spot' for bugs, including exploitable ones used in sophisticated spyware attacks.
          </p>

          <p style={styles.paragraph}>
            Let's take a closer look at just one of these patched vulnerabilities, and see how we can generate a crafted image file capable of triggering an out-of-bounds access violation.
          </p>


          <h3 style={styles.heading3}>The patched code</h3>

          <p style={styles.paragraph}>
            I patch-diff'd the <code style={styles.inlineVariable}>ImageIO</code> framework for both iOS 26.4.2 and 26.5 using IDA Pro.</p>

    {/* <div style={styles.heroImage}>
        <div style={styles.diffImage} />
      </div> */}


<img
  src="https://zygosec.com/imageio_diff.png"
  alt="Description of the screenshot"
  style={styles.blogImage}
/>


<p style={styles.paragraph}>
            A number of functions were modified in this update and we know that at least 3 separate vulnerabilities were patched within this framework according to <a href="https://support.apple.com/en-us/127110" target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: 'rgb(30, 144, 123)'}}>Apple's security notes page.</a> </p>

            <p style={styles.paragraph}>
            I chose to focus on the changes made to <code style={styles.inlineVariable}>EXRReadPlugin::decodeBlockAppleEXR</code> - a function responsible for decoding part of an <a href="https://openexr.com/en/latest/" target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: 'rgb(30, 144, 123)'}}>EXR image</a>. 
          </p>
        

          <p style={{...styles.paragraph, textDecoration: 'line-through'}}>I cannot be sure which CVE this specific change maps to, but here is the relevant snippet of code for both versions nonetheless (minimised for brevity).
          </p>

          <p style={styles.paragraph}>Edit June 4th: This bug is CVE-2026-28990</p>

          <p style={styles.paragraph}>The vulnerable version:
          </p>

          <div style={styles.codeBlock}>
            <div style={styles.codeHeader}>
              <span style={styles.codeLanguage}>iOS 26.4.2</span>
              {/* <button style={styles.copyBtn}>Copy</button> */}
            </div>
            <pre style={styles.code}>{`__int64 __fastcall EXRReadPlugin::decodeBlockAppleEXR(EXRReadPlugin *this, char *a2, __int64 a3)
{
    ...
    if ( this->DecodeToSDR == 1 && this->word1D0 == 0x20 )    [1]
    {
        v16 = 4 * this->dword260 * this->dwordF4;       [2]
        size = v16 * this->unsigned_int138;         [3]
        buf = (char *)malloc_type_malloc(size, type_id: 0x407CBF5u);    [4]
        ...
    }
    ...

}`}</pre>
          </div>


<p style={styles.paragraph}>The patched version:
          </p>

          <div style={styles.codeBlock}>
            <div style={styles.codeHeader}>
              <span style={styles.codeLanguage}>iOS 26.5</span>

            </div>
            <pre style={styles.code}>{`__int64 __fastcall EXRReadPlugin::decodeBlockAppleEXR(EXRReadPlugin *this, char *a2, __int64 a3)
{
    ...
    if ( this->DecodeToSDR != 1 || this->word1D0 != 0x20 ) { 
        ... 
    } else {
        `}<span style={{color: '#1dda9b'}}>{`if ( is_mul_ok(v16, v17) ) [5]`}</span>{`
        {
          a3 = v16 * v17;
          buf = (char *)malloc_type_malloc(size: v16 * v17, type_id: 0xFD4C0FE5);
          ...
        }
        ...
    }
    ...

}`}</pre>
          </div>

          <p style={styles.paragraph}>
            Or in a more visual manner, here is a screenshot of the relevant code snippets from both versions being compared in FileMerge:
          </p>

<img
  src="https://zygosec.com/code_diff.png"
  alt="Description of the screenshot"
  style={styles.blogImage}
/>

      {/* <div style={styles.heroImage}>
          <div style={styles.diffCode}></div>
      </div> */}

          <p style={styles.paragraph}>
            Aside from the block re-ordering that has taken place (presumably a compiler decision), the only meaningful change to this function is the new check added to the multiplication at [2] and [3].
          </p>

          <p style={styles.paragraph}>
            The addition of <code style={styles.inlineVariable}>is_mul_ok</code> at [5] patches an integer overflow that would occur if the values at both [2] and [3] were large enough. Previously, this went completely unchecked and the resulting value would be passed directly into the call to<code style={styles.inlineVariable}>malloc_type_malloc</code> at [4].
          </p>

          <p style={styles.paragraph}>
            In the event of an integer 'wrap around' due to this missing check, the code on the vulnerable version would proceed to allocate a very small buffer based on the wrapped-around size, and then at some point later in the parsing logic would try to copy a large amount of data into this buffer, leading to a heap buffer overflow scenario.
          </p>

          <p style={styles.paragraph}>
            . . . 
          </p>


          <p style={styles.paragraph}>
            As we've now identified the root cause of this bug, let's go a step further and try to reproduce the issue with a working proof-of-concept (PoC). In order to do this, we'll need two things:
          </p>

          <p style={styles.paragraph}>
          1. an application / harness that triggers the vulnerable code path
          </p>
          <p style={styles.paragraph}>
          2. a crafted EXR image that defines large enough values to trigger the integer overflow
          </p>


          <h3 style={styles.heading3}>1. Reaching the vulnerable code</h3>

          <p style={styles.paragraph}>
            The <code style={styles.inlineVariable}>ImageIO</code> framework is called into by many system components and third party applications on both iOS and macOS, often even in operations triggerable without any user interaction. This is what makes <code style={styles.inlineVariable}>ImageIO</code> specifically a good target for 0-click exploits.
          </p>

           <p style={styles.paragraph}>
            Anytime an incoming image file needs to be parsed, it likely goes through <code style={styles.inlineVariable}>ImageIO</code> or one of its related frameworks.
            </p>

           <p style={styles.paragraph}>
  We can reach the interesting code path within <code style={styles.inlineVariable}>ImageIO</code> directly by setting up a small harness program. I'm using some code taken from <a href="https://r00tkitsmm.github.io/fuzzing/2024/03/29/iOSImageIO.html" target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: 'rgb(30, 144, 123)'}}>this blog post</a>.
</p>

<p style={styles.paragraph}>
  We can run this harness on macOS, purely for the convenience factor of being able to easily debug the process. macOS and iOS share much of the same code, and this <code style={styles.inlineVariable}>ImageIO</code> bug is present in both operating systems.
</p>

          <p style={styles.paragraph}>
            With this harness program, we can supply an image filename as input, and then request that <code style={styles.inlineVariable}>ImageIO</code> carry out the appropriate parsing logic by calling the function <code style={styles.inlineVariable}>CGImageSourceCreateImageAtIndex</code>.
          </p>

          <p style={styles.paragraph}>
            If all goes to plan, running this harness program and passing a valid EXR image file as input should invoke the vulnerable function within the <code style={styles.inlineVariable}>ImageIO</code> framework.
          </p>


          <p style={styles.paragraph}>
            Using a random EXR image sample from online, we can run the harness code and have a breakpoint set at <code style={styles.inlineVariable}>EXRReadPlugin::decodeBlockAppleEXR</code>. We see the debugger stops us right as this function, confirming we are hitting the vulnerable code path.
          </p>



          <div style={styles.codeBlock}>
            <div style={styles.codeHeader}>
              <span style={styles.codeLanguage}>lldb</span>

            </div>
            <pre style={styles.code}>{`(lldb) br s -n EXRReadPlugin::decodeBlockAppleEXR
Breakpoint 1: where = ImageIO EXRReadPlugin::decodeBlockAppleEXR(void*, unsigned long), address = 0x000000018d72d530
(lldb) run ~/Downloads/test.exr
Process 51036 launched: 'exr_parser' (arm64)
Process 51036 stopped
* thread #1, queue = 'com.apple.main-thread', stop reason = breakpoint 1.1
    frame #0: 0x00000001929a1530 ImageIO EXRReadPlugin::decodeBlockAppleEXR(void*, unsigned long)
    `}<span style={{color: '#1dda9b'}}>{`
ImageIO EXRReadPlugin::decodeBlockAppleEXR:
->`}</span>{`  0x1929a1530 <+0>:  pacibsp
    0x1929a1534 <+4>:  sub    sp, sp, #0xe0
    0x1929a1538 <+8>:  stp    x28, x27, [sp, #0x80]
    0x1929a153c <+12>: stp    x26, x25, [sp, #0x90]
Target 0: (exr_parser) stopped.
(lldb)
`}</pre></div>

<p style={styles.paragraph}>
            Next, we can single-step through the debugger until we reach the buggy multiplication code. At this point, however, I ran into a problem. There was a check on a value within the <code style={styles.inlineVariable}>EXRReadPlugin</code> object (at [1]) that I was never able to pass. And this check was 'guarding' the vulnerable block itself.
          </p>

          <p style={styles.paragraph}>
            After much experimentation with the input image data itself, I realised that actually this value would only be set to <code style={styles.inlineVariable}>0x1</code> if a specific key/value pair within the optional <code style={styles.inlineVariable}>options</code> dictionary had been passed in to the call to <code style={styles.inlineVariable}>CGImageSourceCreateImageAtIndex</code>.
          </p>


           <p style={styles.paragraph}>
            The key in question was <code style={styles.inlineVariable}>kCGImageSourceDecodeRequest</code>, which needed a value of <code style={styles.inlineVariable}>kCGImageSourceDecodeToSDR</code>, as we can see from the code that sets this flag (in function <code style={styles.inlineVariable}>IIOReadPlugin::IIOReadPlugin</code>):
          </p>


<img
  src="https://zygosec.com/kCGImageSourceDecodeToSDR_image.png"
  alt="Description of the screenshot"
  style={styles.blogImage}
/>
{/* 
      <div style={styles.heroImage}>
          <div style={styles.idaCode}></div>
      </div>
      */}

          <p style={styles.paragraph}>
            I amended the harness code to include this key/value pair as follows:
          </p>


           <div style={styles.codeBlock}>
            <div style={styles.codeHeader}>
              <span style={styles.codeLanguage}>C</span>

            </div>
            <pre style={styles.code}>{``}<span style={{color: '#1dda9b'}}>{`CFStringRef key = CFSTR("kCGImageSourceDecodeRequest");
CFStringRef value = CFSTR("kCGImageSourceDecodeToSDR");

CFDictionaryRef options = CFDictionaryCreate(
    kCFAllocatorDefault,
    (const void **)&key,
    (const void **)&value,
    1,
    &kCFTypeDictionaryKeyCallBacks,
    &kCFTypeDictionaryValueCallBacks
);
`}</span>{`
// Create an image source from the data
CGImageSourceRef source = CGImageSourceCreateWithData(
    (__bridge CFDataRef)data,
    0
);

// Decode into a CGImage (triggering ImageIO parsing)
CGImageRef cgImg = CGImageSourceCreateImageAtIndex(source, 0, `}<span style={{color: '#1dda9b'}}>{`options`}</span>{`);

`}</pre></div>



        <p style={styles.paragraph}>
            By re-running this modified harness via LLDB, I was able to pass this check and reach the problematic multiplication code.
          </p>



        <p style={styles.paragraph}>
            At the first <code style={styles.inlineVariable}>mul</code> instruction, I inspected registers <code style={styles.inlineVariable}>w8</code> and <code style={styles.inlineVariable}>w9</code>.
          </p>

           <div style={styles.codeBlock}>
            <div style={styles.codeHeader}>
              <span style={styles.codeLanguage}>lldb</span>

            </div>
            <pre style={styles.code}>{`* thread #1, queue = 'com.apple.main-thread', stop reason = instruction step over
    frame #0: 0x00000001929a1654 ImageIO EXRReadPlugin::decodeBlockAppleEXR(void*, unsigned long) + 292
ImageIO EXRReadPlugin::decodeBlockAppleEXR:
`}<span style={{color: '#1dda9b'}}>{`->  0x1929a1654 <+292>: mul    w8, w8, w9`}</span>{`
    0x1929a1658 <+296>: lsl    w28, w8, #2
    0x1929a165c <+300>: ldr    w8, [x19, #0x138]
    0x1929a1660 <+304>: mul    w26, w28, w8
Target 0: (exr_parser) stopped.
`}<span style={{color: '#1dda9b'}}>{`(lldb) reg read w8 w9
      w8 = 0x00000003
      w9 = 0x00000040`}</span>{`
      `}
</pre></div>

 <p style={styles.paragraph}>
            And then again at the second multiplication just a few instructions later, I inspected registers <code style={styles.inlineVariable}>w28</code> and <code style={styles.inlineVariable}>w8</code>
          </p>

           <div style={styles.codeBlock}>
            <div style={styles.codeHeader}>
              <span style={styles.codeLanguage}>lldb</span>

            </div>
            <pre style={styles.code}>{`* thread #1, queue = 'com.apple.main-thread', stop reason = instruction step over
    frame #0: 0x00000001929a1660 ImageIO EXRReadPlugin::decodeBlockAppleEXR(void*, unsigned long) + 304
ImageIO EXRReadPlugin::decodeBlockAppleEXR:
`}<span style={{color: '#1dda9b'}}>{`->  0x1929a1660 <+304>: mul    w26, w28, w8`}</span>{`
    0x1929a1664 <+308>: mov    x0, x26
    0x1929a1668 <+312>: mov    w1, #0xcbf5 ; =52213
    0x1929a166c <+316>: movk   w1, #0x407, lsl #16
Target 0: (exr_parser) stopped.
`}<span style={{color: '#1dda9b'}}>{`(lldb) reg read w28 w8
     w28 = 0x00000300
      w8 = 0x00000040`}</span>{`
`}
</pre></div>


<p style={styles.paragraph}>
            These two multiplications can be written more simply as <code style={styles.inlineVariable}>0x3 * 0x40 * 0x40</code>.

          </p>


<p style={styles.paragraph}>
            Given the fact that the sample image I had supplied had a width and height of 64 (which is <code style={styles.inlineVariable}>0x40</code> in hexadecimal), it seemed like a safe assumption that the values used in this multiplication were in fact the width and height derived from the input image.
          </p>


          <p style={styles.paragraph}>
            I was unsure about what the <code style={styles.inlineVariable}>0x3</code> represented, but even if this was constant, it is small enough that by just manipulating the image width and height I'd likely have enough control over the resulting value to cause the intended overflow anyway.
          </p>

          <h3 style={styles.heading3}>2. Generating a crafted EXR image</h3>

          <p style={styles.paragraph}>
            Given our new understanding that the width and height values from the supplied image are used in the buggy multiplication operation, it now only becomes a question of 'how can we generate an image with a large enough width and height?'
          </p>

          <p style={styles.paragraph}>
            My first experiments involved trying to change individual bytes in a hex-editor within the legitimate sample file I had. If the width and height were nicely defined constants somewhere in the image header for example, I should in theory be able to set these to larger values and trigger the overflow this way.
          </p>

          <p style={styles.paragraph}>
            Studying the header for an EXR file, I noticed that the width and height values are actually defined twice - once for the <code style={styles.inlineVariable}>dataWindow</code> and once for the <code style={styles.inlineVariable}>displayWindow</code>. Upon further investigation, I found that the vulnerability occurred only in the calculation for the <code style={styles.inlineVariable}>dataWindow</code>'s buffer.
          </p>


<img
  src="https://zygosec.com/hexView.png"
  alt="Description of the screenshot"
  style={styles.blogImage}
/>

          <p style={styles.paragraph}>
            Mutating the values defined in the <code style={styles.inlineVariable}>dataWindow</code> field in the EXR header didn't work too well however. Any mutations I made resulted in the parser actually bailing out early before reaching the vulnerable <code style={styles.inlineVariable}>ImageIO</code> code:
          </p>


<div style={styles.codeBlock}>
            <div style={styles.codeHeader}>
              <span style={styles.codeLanguage}>lldb</span>

            </div>
            <pre style={styles.code}>{`2026-05-24 11:57:21.090759+0100 exr_parser[80108:3097407] [exr_parser] getImageCount:85: *** axr_data_create failed: axr_error_data_truncated (-4)
2026-05-24 11:57:21.091044+0100 exr_parser[80108:3097407] [exr_parser] createImageAtIndex:2186: *** ERROR: createImageAtIndex[0] - 'EXR ' - failed to create image [-58]
2026-05-24 11:57:21.091051+0100 exr_parser[80108:3097407] [exr_parser] CGImageSourceCreateImageAtIndex:5180: *** ERROR: CGImageSourceCreateImageAtIndex[0] - 'EXR ' - failed to create image [-58]
`}
</pre></div>

          <p style={styles.paragraph}>
            It was clear that the subsequent pixel data needed to match the defined width and height values, so mutating the header values alone was not enough.
          </p>

          <p style={styles.paragraph}>
            With the help of <a href="https://claude.ai/" target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: 'rgb(30, 144, 123)'}}>Claude</a> (which turned out to be quite good at this specific task) I managed to build a Python script capable of generating EXR images on the fly by manually crafting each byte, and writing to an output file.
          </p>

          <p style={styles.paragraph}>
            With this script I was able to tweak various values and generate a whole bunch of test EXR images to run through the parsing code.
          </p>


<img
  src="https://zygosec.com/exr_test_files.png"
  alt="Description of the screenshot"
  style={styles.blogImage}
/>

{/*  
          <div style={styles.contentImage}>
          <div style={styles.exrTestFiles}></div>
          </div> */}

<p style={styles.paragraph}>
            Many of the tests I was playing around with were related to other components within the EXR format, and seeing how different aspects of the image data could affect allocations, etc. But as the focus of this blog is the vulnerability itself, let's only focus on the integer overflow.

          </p>

        
<p style={styles.paragraph}>
            I generated an EXR image with a width value of <code style={styles.inlineVariable}>0x4000</code> (<code style={styles.inlineVariable}>16384</code>) and a height value of <code style={styles.inlineVariable}>0x10000</code> (<code style={styles.inlineVariable}>65536</code>), defined in the <code style={styles.inlineVariable}>dataWindow</code> header field.
          </p>

        


<div style={styles.codeBlock}>
            <div style={styles.codeHeader}>
              <span style={styles.codeLanguage}>exrinfo</span>

            </div>
            <pre style={styles.code}>{`File ' test_overflow.exr':
  compression: 'none'
  displayWindow: [ 0, 0 - 99 99 ] 100 x 100
  `}<span style={{color: '#1dda9b'}}>{`dataWindow: [ 0, 0 - 16383 65535 ] 16384 x 65536`}</span>{`
  channels: 4 channels
   'A': float samp 1 1
   'B': float samp 1 1
   'G': float samp 1 1
   'R': float samp 1 1
`}
</pre></div>

 <p style={styles.paragraph}>
            I also included corresponding pixel data, consisting of a bunch of <code style={styles.inlineVariable}>0x41</code> bytes, to fit these size definitions.
          </p>


<img
  src="https://zygosec.com/zygosec_exr_poc.png"
  alt="Description of the screenshot"
  style={styles.blogImage}
/>



<p style={styles.paragraph}>
            Passing this image into the <code style={styles.inlineVariable}>ImageIO</code> harness, we get a multiplication of <code style={styles.inlineVariable}>0x4 * 0x4000 * 0x10000</code> (the <code style={styles.inlineVariable}>0x3</code> turned out to be configurable to a degree, representing the number of channels for the image. In this file I have it set to <code style={styles.inlineVariable}>0x4</code> instead).
          </p>

          <p style={styles.paragraph}>
            This calculation plays out as follows:
          </p>

          <p style={styles.paragraph}>
            <code style={styles.inlineVariable}>0x4 * 0x4000 == 0x10000</code> 
          </p>
           <p style={styles.paragraph}>
            <code style={styles.inlineVariable}>0x10000 * 0x10000 == 0x1_00000000</code> 
          </p>


          <p style={styles.paragraph}>
            The result of the calculation is <code style={styles.inlineVariable}>0x1_00000000</code> which is too large to fit into a single 32-bit integer, and so it is effectively truncated, resulting in an actual value of <code style={styles.inlineVariable}>0x0</code>.
          </p>


           <p style={styles.paragraph}>
            Running this again through LLDB, we see that after the multiplication occurs, the code takes the result of this multiplication and goes on to call <code style={styles.inlineVariable}>malloc_type_malloc</code> but with a size argument of <code style={styles.inlineVariable}>0x0</code>!
          </p>

          <div style={styles.codeBlock}>
            <div style={styles.codeHeader}>
              <span style={styles.codeLanguage}>lldb</span>

            </div>
            <pre style={styles.code}>{`* thread #1, queue = 'com.apple.main-thread', stop reason = instruction step over
    frame #0: 0x00000001929a1670 ImageIO EXRReadPlugin::decodeBlockAppleEXR(void*, unsigned long) + 320
ImageIO EXRReadPlugin::decodeBlockAppleEXR:
`}<span style={{color: '#1dda9b'}}>{`->  0x1929a1670 <+320>: bl     0x192b1c070    ; symbol stub for: malloc_type_malloc`}</span>{`
    0x1929a1674 <+324>: mov    x27, x0
    ...
(lldb) reg read x0
`}<span style={{color: '#1dda9b'}}>{`      x0 = 0x0000000000000000 <- 1st argument (size) of 0x0!`}</span>{`
`}
</pre></div>


<p style={styles.paragraph}>
            You may be under the impression that trying to call <code style={styles.inlineVariable}>malloc</code> with a request size of <code style={styles.inlineVariable}>0x0</code> would just fail.
          </p>

<p style={styles.paragraph}>
            But no - it actually turns out that <code style={styles.inlineVariable}>malloc</code> still returns a valid pointer to an allocation, just of the minimum allocation size of <code style={styles.inlineVariable}>16</code> bytes. We can confirm this by calling <code style={styles.inlineVariable}>malloc_size</code> on the returned value inside the debugger.
          </p>

<div style={styles.codeBlock}>
            <div style={styles.codeHeader}>
              <span style={styles.codeLanguage}>lldb</span>

            </div>
            <pre style={styles.code}>{`(lldb) reg read x0
      x0 = 0x000000010061b780
(lldb) print (int)malloc_size((void*)0x000000010061b780)
(int) `}<span style={{color: '#1dda9b'}}>{`16   <- allocation size 16`}</span>{`
(lldb)
`}
</pre></div>


 <p style={styles.paragraph}>
            So we now have a tiny allocation of just <code style={styles.inlineVariable}>16</code> bytes that was intended to be used to hold much more data than this. The natural thing to expect next is some kind of crash, which is exactly what happens.
          </p>


<div style={styles.codeBlock}>
            <div style={styles.codeHeader}>
              <span style={styles.codeLanguage}>lldb</span>

            </div>
            <pre style={styles.code}>{`* thread #1, queue = 'com.apple.main-thread', stop reason = `}<span style={{color: '#e63030'}}>{`EXC_BAD_ACCESS (code=1, address=0x50061b77f)`}</span>{`
    frame #0: 0x00000001d8bc9308 libAppleEXR.dylib `}<span style={{color: '#1dda9b'}}>{`AppleEXRDestinationNotBigEnough`}</span>{` + 20
libAppleEXR.dylib `}<span style={{color: '#1dda9b'}}>{`AppleEXRDestinationNotBigEnough:`}</span>{`
->  0x1d8bc9308 <+20>: sturb  wzr, [x8, #-0x1]
    0x1d8bc930c <+24>: ret
`}
</pre></div>


<p style={styles.paragraph}>
            This is the first crash I got when parsing the crafted image. It is inside the function <code style={styles.inlineVariable}>AppleEXRDestinationNotBigEnough</code> which is called by <code style={styles.inlineVariable}>Part::ReadRGBAPixels</code>. By just reading its name, it seemed to be some fatal error handler for this specific under-sized allocation issue.
          </p>

<p style={styles.paragraph}>
            I was initially disappointed when I saw this, as typically there isn't as much exploitability in cases where a fatal error is actually caught by the program and forcefully terminated. Ideally we want some uncaught exception, due to an invalid memory access, that we can actually leverage to build interesting primitives on top of.
          </p>


          <p style={styles.paragraph}>
            Upon further examination however, it seemed that this function actually wasn't just forcefully terminating the program. What it was actually doing was trying to write a <code style={styles.inlineVariable}>NULL</code> byte to the very end of the allocated buffer.
          </p>

          <p style={styles.paragraph}>
            It was calculating the end of the buffer through another multiplication - this time one that did not involve 32-bit integers, but rather 64-bit integers. The overflow and truncation therefore did not occur in this instance, and so the code was actually using the real calculated size (an enormous value) and was adding it to the base address of the allocated buffer (the pointer returned by <code style={styles.inlineVariable}>malloc_type_malloc</code>).
          </p>

          <p style={styles.paragraph}>
            The resulting address was invalid and so the parser was crashing with <code style={styles.inlineVariable}>EXC_BAD_ACCESS</code>.

            </p>

            <div style={styles.codeBlock}>
            <div style={styles.codeHeader}>
              <span style={styles.codeLanguage}>lldb</span>

            </div>
            <pre style={styles.code}>{``}<span style={{color: '#e63030'}}>{`->  0x1d8bc9308 <+20>: sturb  wzr, [x8, #-0x1]`}</span>{`
    0x1d8bc930c <+24>: ret
(lldb) reg read x8
      x8 = 0x000000050061b780
(lldb) mem region 0x000000050061b780
[0x000000050061b780-0x0000000552000000) ---
(lldb) x/1gx 0x000000050061b780
`}<span style={{color: '#e63030'}}>{`error:`}</span>{` memory read failed for 0x50061b600
(lldb)
`}
</pre></div>


        <p style={styles.paragraph}>
            And a visual to go along with that:
          </p>





<img
  src="https://zygosec.com/exr_oob_visual.png"
  alt="Description of the screenshot"
  style={styles.blogImage}
/>


{/* 
      <div style={styles.heroImage}>
          <div style={styles.exrVisual}></div>
      </div> */}


        <p style={styles.paragraph}>
            The solution to avoid this crash is to have this write operation succeed. And the only way to do that is to make it such that the address being written to is in fact a valid mapped memory address.

            </p>


            <p style={styles.paragraph}>
            If you were to build an exploit for this bug you'd likely implement some form of heap shaping in order to increase the reliability of this, but in my tests I actually didn't need to do anything more. It turned out that on around ~20% of runs, the address that <code style={styles.inlineVariable}>AppleEXRDestinationNotBigEnough</code> was trying to write to actually did point to legitimate memory, and so the <code style={styles.inlineVariable}>NULL</code> byte was written, and execution continued past this function.
            </p>


            <p style={styles.paragraph}>
            In those cases, I was presented a much more interesting crash that occurred later on in the parsing pipeline.
            </p>


<div style={styles.codeBlock}>
            <div style={styles.codeHeader}>
              <span style={styles.codeLanguage}>lldb</span>

            </div>
            <pre style={styles.code}>{`  thread #6, queue = 'com.apple.root.user-interactive-qos', `}<span style={{color: '#e63030'}}>{`stop reason = EXC_GUARD (code=1, subcode=0x4141414141414151)`}</span>{`
    frame #0: 0x00000001855ba8c8 libdispatch.dylib _dispatch_root_queue_drain + 176
libdispatch.dylib _dispatch_root_queue_drain:
`}<span style={{color: '#e63030'}}>{`->  0x1855ba8c8 <+176>: ldr    x8, [x0, #0x10]!`}</span>{`
    0x1855ba8cc <+180>: cbz    x8, 0x1855bab2c ; <+788>
    0x1855ba8d0 <+184>: str    x8, [x20, #0x68]
    0x1855ba8d4 <+188>: mov    x0, x20
Target 0: (exr_parser) stopped.
(lldb) reg read x0
`}<span style={{color: '#e63030'}}>{`      x0 = 0x4141414141414141`}</span>{`
(lldb)
`}
</pre></div>


  <p style={styles.paragraph}>
            Here we see that the program is trying to dereference address <code style={styles.inlineVariable}>0x4141414141414141</code>!
            </p>


  <p style={styles.paragraph}>
            Recall that the pixel data within the crafted EXR file is made up of <code style={styles.inlineVariable}>0x41</code> bytes, so we can infer that the under-sized allocation and the subsequent copy operations have led to the pixel data corrupting process memory.
            </p>

          <p style={styles.paragraph}>
            The backtrace from the point of crash can give us some indication of what was going on inside the parser at that point in time.
            </p>


            <div style={styles.codeBlock}>
            <div style={styles.codeHeader}>
              <span style={styles.codeLanguage}>lldb</span>

            </div>
            <pre style={styles.code}>{`(lldb) bt
* thread #1, queue = 'com.apple.root.user-interactive-qos', stop reason = `}<span style={{color: '#e63030'}}>{`EXC_GUARD (code=1, subcode=0x4141414141414149)`}</span>{`
  * frame #0: 0x00000001855bd01c libdispatch.dylib _dispatch_apply_set_attr_behavior + 16
    frame #1: 0x00000001855bd718 libdispatch.dylib _dispatch_apply_invoke_and_wait + 64
    frame #2: 0x00000001855bc944 libdispatch.dylib _dispatch_apply_with_attr_f + 1312
    frame #3: 0x00000001d8bd33b4 libAppleEXR.dylib `}<span style={{color: '#1dda9b'}}>{`axr_error_t LaunchBlocks<ReadPixelsArgs>(void (*)(void*, unsigned long), ReadPixelsArgs const*, unsigned long, axr_flags_t) + 472`}</span>{`
    frame #4: 0x00000001d8bd2ff4 libAppleEXR.dylib `}<span style={{color: '#1dda9b'}}>{`TileDecoder::ReadPixels(unsigned int, unsigned int, void*, unsigned long) const + 156`}</span>{`
    frame #5: 0x00000001d8bc9d70 libAppleEXR.dylib `}<span style={{color: '#1dda9b'}}>{`Part::ReadRGBAPixels(axr_decoder*, void*, unsigned long, double, axr_flags_t) const + 1848`}</span>{`
    frame #6: 0x00000001929a1724 ImageIO EXRReadPlugin::decodeBlockAppleEXR(void*, unsigned long) + 500
    frame #7: 0x00000001929a1400 ImageIO EXRReadPlugin::decodeImageImp(IIODecodeParameter*, IIOImageType, __IOSurface**, __CVBuffer**, CGImageBlockSet**) + 612
    frame #8: 0x000000019295a8e4 ImageIO IIOReadPlugin::callDecodeImage(IIODecodeParameter*, IIOImageType, __IOSurface**, __CVBuffer**, CGImageBlockSet**) + 1000
    frame #9: 0x00000001928a6b04 ImageIO IIO_Reader::CopyImageBlockSetProc(void*, CGImageProvider*, CGRect, CGSize, __CFDictionary const*) + 708
    frame #10: 0x00000001928c2984 ImageIO IIOImageProviderInfo::copyImageBlockSetWithOptions(CGImageProvider*, CGRect, CGSize, __CFDictionary const*) + 408
    frame #11: 0x00000001928a6670 ImageIO IIOImageProviderInfo::CopyImageBlockSetWithOptions(void*, CGImageProvider*, CGRect, CGSize, __CFDictionary const*) + 908
    ...`}
</pre></div>


<p style={styles.paragraph}>
            You can see from this backtrace that the crash is occuring in part of the deeper EXR-specific parsing code within the <code style={styles.inlineVariable}>libAppleEXR.dylib</code> library.
            </p>

          <h3 style={styles.heading3}>Exploitability?</h3>

          <p style={styles.paragraph}>
            I haven't conducted much further analysis beyond the points discussed in this post. So while I cannot provide an clear insight into the exploitability of this, we know that the bug at least has the characteristics that a typical 'good' memory corruption bug would have.
          </p>

          <p style={styles.paragraph}>
            • We have an under-sized allocation, with the potential for a heap overflow
          </p>


          <p style={styles.paragraph}>
            • We have demonstrated that deferencing an arbitrary pointer is possible by corrupting process memory with pixel data
          </p>


          <p style={styles.paragraph}>
            • We have significant influence over prior and subsequent parsing operations, as we control the entire image data, so implementing a heap groom is probably doable
          </p>

. . .
          <p style={styles.paragraph}>
            Another interesting point of consideration with this bug specifically would be the reachable attack paths on a real target device.
          </p>

          <p style={styles.paragraph}>
            We looked exclusively at triggering the bug through a controlled harness that called into the relevant parsing functions. But recall from earlier, we had to set a specific dictionary key and value pair on an object that had to be passed to the original decoder function.
          </p>

          <p style={styles.paragraph}>
            We aren't able to influence this with the image data itself, because it occurs before the parsing begins. So in order to evaluate whether or not this bug could actually be reached from within a 'real' target context (such as through something like iMessage, or a third party app like WhatsApp) you'd have to first understand the logic surrounding the setting of that specific key/value pair, and ultimately figure out a way to have that occur every time the target tries to decode an EXR image.
          </p>

          . . .

          <p style={styles.paragraph}>
            The PoC EXR image file used, as well as the harness code, can be found on the Github repo linked <a href="https://github.com/Billy-Ellis/exr-imageio-poc" target="_blank" rel="noopener noreferrer" style={{textDecoration: 'none', color: 'rgb(30, 144, 123)'}}>here</a>.
          </p>

          <p style={styles.paragraph}>
            ~ @bellis1000
          </p>



        </div>

        {/* Author Bio */}
        <div style={styles.authorBio}>
          <div style={styles.authorBioAvatar}></div>
          <div style={styles.authorBioContent}>
            <h3 style={styles.authorBioName}>Billy Ellis</h3>
            <p style={styles.authorBioText}>
              iOS security researcher 
            </p>
          </div>
        </div>

      </article>

      {/* Footer */}
      <footer style={styles.footer}>
        <div className="footer-inner" style={styles.footerInner}>
          <div style={styles.footerBrand}>
            <div style={styles.logo}>
              <a>
                <img style={{width: '100px', padding: 0, margin: 0}} class="w-[100px] p-0 m-0" src={require('../images/zygosec-dark.png')} id="logo"/>
              </a>
            </div>
            <p style={styles.footerTagline}>
              Acquire skills in vulnerability research, reverse engineering & exploit development.
            </p>
          </div>
          <div className="footer-links" style={styles.footerLinks}>
            <div style={styles.footerCol}>
              <h4 style={styles.footerHeading}>Resources</h4>
              <a href="https://zygosec.com/blog" style={styles.footerLink}>Blog</a>
              <a href="https://www.youtube.com/@BillyEllis" style={styles.footerLink}>YouTube</a>
            </div>
            <div style={styles.footerCol}>
              <h4 style={styles.footerHeading}>Company</h4>
              <a href="/about" style={styles.footerLink}>About</a>
            </div>
          </div>
        </div>
        <div style={styles.footerBottom}>
          <span>© 2026 ZygoSec</span>
          <div style={styles.legalLinks}>
            <a href="#" style={styles.legalLink}>Privacy</a>
            <a href="#" style={styles.legalLink}>Terms</a>
          </div>
        </div>
      </footer>
    </div>
  );
};

const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#ffffff',
    color: '#111827',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
    position: 'relative'
  },
  dotPattern: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundImage: 'radial-gradient(#d1d5db 1px, transparent 1px)',
    backgroundSize: '24px 24px',
    opacity: 0.5,
    pointerEvents: 'none',
    zIndex: 0
  },
  nav: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: 'rgba(255,255,255,0.9)',
    backdropFilter: 'blur(12px)',
    borderBottom: '1px solid #f3f4f6',
    zIndex: 100
  },
  navInner: {
    maxWidth: '1120px',
    margin: '0 auto',
    padding: '16px 24px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  logo: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  logoMark: {
    fontSize: '22px',
    color: '#0d9488'
  },
  logoText: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#111827',
    letterSpacing: '-0.5px'
  },
  navLinks: {
    display: 'flex',
    gap: '32px'
  },
  navLink: {
    color: '#6b7280',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: 500
  },
  navActions: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  },
  signIn: {
    color: '#6b7280',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: 500
  },
  startBtn: {
    backgroundColor: '#0d9488',
    color: '#ffffff',
    border: 'none',
    padding: '10px 20px',
    borderRadius: '8px',
    fontSize: '14px',
    fontWeight: 500,
    cursor: 'pointer'
  },
  mobileMenuBtn: {
    display: 'none',
    alignItems: 'center',
    justifyContent: 'center',
    width: '40px',
    height: '40px',
    backgroundColor: 'transparent',
    border: '1px solid #e5e7eb',
    borderRadius: '8px',
    fontSize: '18px',
    cursor: 'pointer',
    color: '#374151'
  },
  mobileMenu: {
    display: 'flex',
    flexDirection: 'column',
    padding: '16px 24px',
    borderTop: '1px solid #f3f4f6',
    backgroundColor: '#ffffff'
  },
  mobileNavLink: {
    padding: '12px 0',
    color: '#374151',
    textDecoration: 'none',
    fontSize: '16px',
    fontWeight: 500,
    borderBottom: '1px solid #f3f4f6'
  },
  articleHeader: {
    position: 'relative',
    zIndex: 1,
    maxWidth: '800px',
    margin: '0 auto',
    padding: '100px 24px 48px'
  },
  headerContent: {},
  backLink: {
    display: 'inline-block',
    color: '#0d9488',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: '24px'
  },
  articleCategory: {
    display: 'inline-block',
    backgroundColor: 'rgba(13, 148, 136, 0.1)',
    color: '#0d9488',
    padding: '6px 12px',
    borderRadius: '100px',
    fontSize: '12px',
    fontWeight: 600,
    marginBottom: '16px'
  },
  articleTitle: {
    fontSize: '42px',
    fontWeight: 700,
    color: '#111827',
    lineHeight: 1.2,
    marginBottom: '16px',
    letterSpacing: '-1px'
  },
  articleSubtitle: {
    fontSize: '18px',
    color: '#6b7280',
    lineHeight: 1.6,
    marginBottom: '32px'
  },
  articleMeta: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  authorInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px'
  },
  authorAvatar: {
    width: '48px',
    height: '48px',
    borderRadius: '50%',
    backgroundColor: '#0d9488',
    backgroundImage: 'url(https://pbs.twimg.com/profile_images/1958650347833950211/ebbVYr3z_400x400.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    fontSize: '14px'
  },
  authorName: {
    display: 'block',
    fontWeight: 600,
    color: '#111827',
    fontSize: '14px'
  },
  articleDate: {
    display: 'block',
    color: '#9ca3af',
    fontSize: '13px',
    marginTop: '2px'
  },
  shareButtons: {
    display: 'flex',
    gap: '8px'
  },
  shareBtn: {
    width: '36px',
    height: '36px',
    borderRadius: '8px',
    border: '1px solid #e5e7eb',
    backgroundColor: '#ffffff',
    cursor: 'pointer',
    fontSize: '14px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  contentImage: {
    position: 'relative',
    zIndex: 1,
    maxWidth: '900px',
    margin: '0 auto',
    // padding: '0 24px 48px'
  },
  heroImage: {
    position: 'relative',
    zIndex: 1,
    maxWidth: '900px',
    margin: '0 auto',
    padding: '0 24px 48px'
  },
  heroImageInner: {
    height: '270px',
    borderRadius: '16px',
    backgroundImage: 'url(https://zygosec.com/exr_rca_3.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundColor: '#1a1a2e'
  },
  diffImage: {
    height: '270px',
    borderRadius: '16px',
    backgroundImage: 'url(https://zygosec.com/imageio_diff.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundColor: '#1a1a2e'
  },
  diffCode: {
    height: '350px',
    borderRadius: '16px',
    backgroundImage: 'url(https://zygosec.com/code_diff.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  idaCode: {
    height: '350px',
    borderRadius: '16px',
    backgroundImage: 'url(https://zygosec.com/kCGImageSourceDecodeToSDR_image.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  exrVisual: {
    height: '200px',
    borderRadius: '16px',
    backgroundImage: 'url(https://zygosec.com/exr_oob_visual.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  exrTestFiles: {
    height: '250px',
    borderRadius: '16px',
    backgroundImage: 'url(https://zygosec.com/exr_test_files.png)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  blogImage: {
  width: '100%',
  height: 'auto',
  borderRadius: '10px',
  // border: '1px solid #e5e7eb',
  display: 'block',
  marginBottom: '28px'
},
  genericImage: {
    height: '350px',
    borderRadius: '16px',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundColor: '#1a1a2e'
  },
  articleContent: {
    position: 'relative',
    zIndex: 1,
    maxWidth: '700px',
    margin: '0 auto',
    padding: '0 24px 80px'
  },
  prose: {},
  leadParagraph: {
    fontSize: '20px',
    lineHeight: 1.7,
    color: '#374151',
    marginBottom: '24px',
    fontWeight: 500
  },
  paragraph: {
    fontSize: '17px',
    lineHeight: 1.8,
    color: '#374151',
    marginBottom: '24px'
  },
  heading2: {
    fontSize: '28px',
    fontWeight: 700,
    color: '#111827',
    marginTop: '48px',
    marginBottom: '20px',
    letterSpacing: '-0.5px'
  },
  heading3: {
    fontSize: '20px',
    fontWeight: 600,
    color: '#111827',
    marginTop: '32px',
    marginBottom: '16px'
  },
  list: {
    marginBottom: '24px',
    paddingLeft: '24px'
  },
  listItem: {
    fontSize: '17px',
    lineHeight: 1.8,
    color: '#374151',
    marginBottom: '8px'
  },
  inlineCode: {
    backgroundColor: '#f3f4f6',
    padding: '2px 6px',
    borderRadius: '4px',
    fontFamily: '"SF Mono", "Fira Code", monospace',
    fontSize: '15px',
    color: '#dc2626'
  },
  inlineVariable: {
    backgroundColor: '#f3f4f6',
    padding: '2px 6px',
    borderRadius: '4px',
    fontFamily: '"SF Mono", "Fira Code", monospace',
    fontSize: '15px',
    color: '#191919'
  },
  codeBlock: {
    backgroundColor: '#1e293b',
    borderRadius: '12px',
    overflow: 'hidden',
    marginBottom: '24px'
  },
  codeHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
    backgroundColor: '#334155',
    borderBottom: '1px solid #475569'
  },
  codeLanguage: {
    fontSize: '12px',
    color: '#94a3b8',
    fontWeight: 500
  },
  copyBtn: {
    backgroundColor: 'transparent',
    border: '1px solid #475569',
    color: '#94a3b8',
    padding: '4px 12px',
    borderRadius: '4px',
    fontSize: '12px',
    cursor: 'pointer'
  },
  code: {
    margin: 0,
    padding: '20px',
    fontFamily: '"SF Mono", "Fira Code", monospace',
    fontSize: '13px',
    lineHeight: 1.7,
    color: '#e2e8f0',
    overflowX: 'auto'
  },
  codeHighlight: {
    margin: 0,
    padding: '20px',
    fontFamily: '"SF Mono", "Fira Code", monospace',
    fontSize: '13px',
    lineHeight: 1.7,
    color: '#25d89f',
    overflowX: 'auto'
  },
  infoBox: {
    backgroundColor: '#f0f9ff',
    border: '1px solid #bae6fd',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '24px'
  },
  infoBoxHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '8px'
  },
  infoBoxIcon: {
    fontSize: '18px'
  },
  infoBoxTitle: {
    fontWeight: 600,
    color: '#0369a1',
    fontSize: '14px'
  },
  infoBoxContent: {
    fontSize: '15px',
    color: '#0c4a6e',
    lineHeight: 1.6,
    margin: 0
  },
  warningBox: {
    backgroundColor: '#fefce8',
    border: '1px solid #fde047',
    borderRadius: '12px',
    padding: '20px',
    marginBottom: '24px'
  },
  warningBoxHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginBottom: '8px'
  },
  warningBoxIcon: {
    fontSize: '18px'
  },
  warningBoxTitle: {
    fontWeight: 600,
    color: '#a16207',
    fontSize: '14px'
  },
  warningBoxContent: {
    fontSize: '15px',
    color: '#713f12',
    lineHeight: 1.6,
    margin: 0
  },
  tags: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    marginTop: '48px',
    paddingTop: '32px',
    borderTop: '1px solid #e5e7eb'
  },
  tag: {
    backgroundColor: '#f3f4f6',
    color: '#6b7280',
    padding: '6px 14px',
    borderRadius: '100px',
    fontSize: '13px',
    fontWeight: 500
  },
  authorBio: {
    display: 'flex',
    gap: '20px',
    marginTop: '48px',
    padding: '32px',
    backgroundColor: '#f9fafb',
    borderRadius: '16px'
  },
  authorBioAvatar: {
    width: '64px',
    height: '64px',
    borderRadius: '50%',
    backgroundImage: 'url(https://pbs.twimg.com/profile_images/1958650347833950211/ebbVYr3z_400x400.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 600,
    fontSize: '18px',
    flexShrink: 0
  },
  authorBioContent: {},
  authorBioName: {
    fontSize: '18px',
    fontWeight: 600,
    color: '#111827',
    marginBottom: '3px'
  },
  authorBioText: {
    fontSize: '14px',
    color: '#6b7280',
    lineHeight: 1.6,
    marginBottom: '12px',
    marginTop: '0px'
  },
  authorBioLink: {
    color: '#0d9488',
    textDecoration: 'none',
    fontSize: '14px',
    fontWeight: 500
  },
  relatedPosts: {
    marginTop: '64px'
  },
  relatedTitle: {
    fontSize: '20px',
    fontWeight: 600,
    color: '#111827',
    marginBottom: '24px'
  },
  relatedGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    gap: '24px'
  },
  relatedCard: {
    cursor: 'pointer'
  },
  relatedImage: {
    height: '140px',
    borderRadius: '12px',
    marginBottom: '16px'
  },
  relatedCardTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: '#111827',
    marginBottom: '8px',
    lineHeight: 1.4
  },
  relatedCardMeta: {
    fontSize: '13px',
    color: '#9ca3af'
  },
  footer: {
    position: 'relative',
    zIndex: 1,
    borderTop: '1px solid #f3f4f6',
    padding: '64px 24px 32px',
    backgroundColor: 'rgba(255,255,255,0.9)'
  },
  footerInner: {
    maxWidth: '1120px',
    margin: '0 auto',
    display: 'grid',
    gridTemplateColumns: '1fr 2fr',
    gap: '64px',
    marginBottom: '48px'
  },
  footerBrand: {},
  footerTagline: {
    fontSize: '14px',
    color: '#9ca3af',
    marginTop: '12px'
  },
  footerLinks: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '32px'
  },
  footerCol: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px'
  },
  footerHeading: {
    fontSize: '13px',
    fontWeight: 600,
    color: '#111827',
    marginBottom: '4px'
  },
  footerLink: {
    fontSize: '14px',
    color: '#6b7280',
    textDecoration: 'none'
  },
  footerBottom: {
    maxWidth: '1120px',
    margin: '0 auto',
    paddingTop: '32px',
    borderTop: '1px solid #f3f4f6',
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '13px',
    color: '#9ca3af'
  },
  legalLinks: {
    display: 'flex',
    gap: '24px'
  },
  legalLink: {
    color: '#9ca3af',
    textDecoration: 'none'
  }
};

export default ZygoSecBlogPost;
